import { Component, Input } from '@angular/core';
import { UserOne } from '@models/userone';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-user-info-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './app-user-info-card.component.html',
  styleUrl: './app-user-info-card.component.css'
})
export class AppUserInfoCardComponent {
  @Input() user: UserOne;

  getUserInitials(): string {
    if (!this.user) return '';
    const firstInitial = this.user.firstName ? this.user.firstName.charAt(0).toUpperCase() : '';
    const lastInitial = this.user.lastName ? this.user.lastName.charAt(0).toUpperCase() : '';
    return firstInitial + lastInitial;
  }

  getUserFullName(): string {
    if (!this.user) return '';
    return `${this.user.firstName || ''} ${this.user.lastName || ''}`.trim();
  }
}
